import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  path: {
    fill: 'currentColor',
  },
});

// Mozilla wordmark, sourced from
// https://people.mozilla.org/img/mozilla.f0eb4720.svg. Inlined so it
// renders without a network request and inherits color via
// `currentColor` so the theme controls it.
const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 983.6 235.2"
    >
      <path
        className={classes.path}
        d="M54.6 88.2l18.7 92H80l18.7-92h54.6v144.9h-29.8V113.6h-6.7l-26 119.5H62.6l-26-119.5h-6.7v119.5H0V88.2h54.6zm171.1 30.7c34.4 0 54.4 20.6 54.4 58.2s-19.9 58.2-54.4 58.2-54.4-20.6-54.4-58.2c.1-37.7 20-58.2 54.4-58.2zm0 93.2c15.5 0 22.9-8.4 22.9-26.9v-16.4c0-18.5-7.3-26.9-22.9-26.9s-22.9 8.4-22.9 26.9v16.4c.1 18.5 7.4 26.9 22.9 26.9zm66.6-.6l56.9-68.9h-56.1V121h91.6v21.6l-56.9 68.9h57.7v21.6h-93.2v-21.6zM401.1 121h42v112.1h-29.8v-90.5h-12.2V121zm12.2-32.8h29.8v21.6h-29.8V88.2zm49.5 0h42v144.9H475V109.8h-12.2V88.2zm61.8 0h42v144.9h-29.8V109.8h-12.2V88.2zm106 30.7c16.6 0 27.5 8.2 30.7 22.5h6.7V121h35.5v21.6h-12.2v68.9h12.2v21.6h-17c-12 0-18.5-6.5-18.5-18.5v-1.9h-6.7c-3.2 14.3-14.1 22.5-30.7 22.5-26.2 0-44.7-22.3-44.7-58.2 0-35.9 18.5-58.1 44.7-58.1zm8.8 93.2c15.1 0 22-8.4 22-26.9v-16.4c0-18.5-6.9-26.9-22-26.9s-22 8.4-22 26.9v16.4c0 18.5 6.9 26.9 22 26.9zm175 21h-29.8V0h29.8v233.1zm24.3-114.2h118v-6.7l-76.9-27.9V60.7l76.9-27.9V26h-91.1V0h118v47.5L921 69.1v6.7l62.6 21.6v47.5H838.7v-26zm0-92.9h26.9v26.9h-26.9V26z"
      />
    </svg>
  );
};

export default LogoFull;
